@if (dataFormGroup && IndividualType === 1) {
  <form [formGroup]="dataFormGroup" class="bv-form-grid">
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.NAME' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="name" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.COUNTRY' | translate }}</label>
      <mat-select class="bv-select" formControlName="countries_id">
        @for (item of countriesList; track item) {
          <mat-option [value]="item.id">{{item.description}}</mat-option>
        }
      </mat-select>
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'UBICATION.JURISDICTION' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="jurisdiction" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.NATIONALITY' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="nationality" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.LEGAL_REPRESENTATIVE' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="legal_representative" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{'BY_COUNTRY.'+countryCode+'.INDIVIDUALS.LEGAL_DOCUMENT_TYPE' | translate}}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="cuit" />
    </div>
  </form>
}

@if (dataFormGroup && IndividualType === 0) {
  <form [formGroup]="dataFormGroup" class="bv-form-grid">
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.NAME' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="name" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.LAST_NAME' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="last_name" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.EMAIL' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="email" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.COUNTRY' | translate }}</label>
      <mat-select class="bv-select" formControlName="countries_id">
        @for (item of countriesList; track item) {
          <mat-option [value]="item.id">{{item.description | translate}}</mat-option>
        }
      </mat-select>
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.PHONE' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="phone" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.DOC_TYPE' | translate }}</label>
      <mat-select class="bv-select" formControlName="document_type">
        @for (item of documentTypesList; track item) {
          <mat-option [value]="item">{{item}}</mat-option>
        }
      </mat-select>
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.DOCUMENT' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="document" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{'BY_COUNTRY.'+countryCode+'.INDIVIDUALS.LEGAL_DOCUMENT_TYPE' | translate}}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="cuit" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.BIRTH' | translate }}</label>
      <div class="input-group">
        <input type="text" class="form-control" autocomplete="off"
          formControlName="birthday" [matDatepicker]="picker" (focus)="picker.open()" readonly />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </div>
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.OCCUPATION' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="occupation" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.NATIONALITY' | translate }}</label>
      <input type="text" class="form-control" autocomplete="off" formControlName="nationality" />
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.MARITAL_STATUS' | translate }}</label>
      <mat-select class="bv-select" formControlName="marital_status">
        @for (item of maritalStatusList; track item) {
          <mat-option [value]="item">{{item | translate}}</mat-option>
        }
      </mat-select>
    </div>
    <div class="bv-form-grid__field">
      <label>{{ 'LABELS.TITLE' | translate }}</label>
      <mat-select class="bv-select" formControlName="individual_prefixes_id">
        @for (item of prefixes; track item) {
          <mat-option [value]="item.id">{{item.description | translate}}</mat-option>
        }
      </mat-select>
    </div>
  </form>
}
